module.exports = __webpack_public_path__ + "static/aboutus-fc189a25dbcfc7c4333e891476378803.webp";